export type ReplayReadyPayload = {
  remoteId: string;
  replayUrl: string;
  flightName?: string;
};

type ReplayReadyListener = (payload: ReplayReadyPayload) => void;

const listeners = new Set<ReplayReadyListener>();

export function onReplayReady(listener: ReplayReadyListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function emitReplayReady(payload: ReplayReadyPayload): void {
  for (const listener of listeners) {
    try {
      listener(payload);
    } catch (err) {
      console.error('[replay] ready listener failed:', err);
    }
  }
}
